const TABLEAU_API_PATH = "/javascripts/api/tableau.embedding.3.latest.min.js";

let loadPromise: Promise<void> | null = null;

/**
 * Loads the Tableau Embedding API v3 module script from the given pod origin,
 * which registers the <tableau-viz> custom element. The script is injected
 * once per session and shared across calls. The origin is derived from the
 * backend-provided embed URL so it always matches the embedded view's pod.
 */
export const loadTableauEmbeddingApi = (embedUrl: string): Promise<void> => {
  if (loadPromise) {
    return loadPromise;
  }

  if (typeof window !== "undefined" && window.customElements?.get("tableau-viz")) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  const { origin } = new URL(embedUrl);
  const src = `${origin}${TABLEAU_API_PATH}`;

  loadPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Failed to load Tableau Embedding API")));
      return;
    }

    const script = document.createElement("script");
    script.type = "module";
    script.src = src;
    script.async = true;
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", () => {
      loadPromise = null;
      reject(new Error("Failed to load Tableau Embedding API"));
    });
    document.head.appendChild(script);
  });

  return loadPromise;
};
